(function () {
  var VISIBLE_COUNT = 9;
  var MIN_ITEMS = 11;

  function parseProductData(section) {
    var root = section.closest('.shopify-section') || section;
    var dataScript = root.querySelector('script[data-section-data][data-section-type="product"]');
    if (!dataScript) return null;

    try {
      return JSON.parse(dataScript.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function findVariant(productData, variantId) {
    if (!productData || !productData.product || !Array.isArray(productData.product.variants)) {
      return null;
    }

    return (
      productData.product.variants.find(function (variant) {
        return String(variant.id) === String(variantId);
      }) || null
    );
  }

  function getVariantImageUrl(variant) {
    if (!variant) return null;
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
      return variant.featured_media.preview_image.src;
    }
    return null;
  }

  function getVariantMediaId(variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
    return null;
  }

  function getActiveSlide(gallery) {
    return (
      gallery.querySelector('.product-gallery__slide.is-selected[data-media-type="image"]') ||
      gallery.querySelector('.product-gallery__slide[data-media-type="image"]')
    );
  }

  function updateSlideImage(slide, variant) {
    var imageUrl = getVariantImageUrl(variant);
    if (!slide || !variant || !imageUrl) return;

    var image = slide.querySelector('img');
    var link = slide.querySelector('a.product-gallery__link');
    var alt = (variant.featured_image && variant.featured_image.alt) || variant.name || variant.title || '';
    var mediaId = getVariantMediaId(variant);

    if (mediaId) {
      slide.dataset.imageId = mediaId;
    }

    slide.dataset.title = alt;

    if (image) {
      image.src = imageUrl;
      image.removeAttribute('srcset');
      image.dataset.rimg = 'loaded';
      image.alt = alt || 'image';
    }

    if (link) {
      link.href = imageUrl;
      link.title = alt;
      link.dataset.alt = alt;
    }
  }

  function setSlideMediaId(slide, variant) {
    var mediaId = getVariantMediaId(variant);
    if (slide && mediaId) {
      slide.dataset.imageId = mediaId;
    }
  }

  function syncGalleryToVariant(section, variant, updateImage) {
    if (!variant) return;

    var gallery = section.querySelector('[data-variant-gallery]');
    if (!gallery) return;

    var slide = getActiveSlide(gallery);
    if (!slide) return;

    if (updateImage) {
      updateSlideImage(slide, variant);
    } else {
      setSlideMediaId(slide, variant);
    }
  }

  function getSelectedVariantId(section) {
    var variantSelection = section.querySelector('[data-variant-selection]');
    if (variantSelection) {
      var selectedId = variantSelection.getAttribute('variant');
      if (selectedId && selectedId !== 'not-selected') return selectedId;
    }

    var input = section.querySelector('select[name="id"], input[name="id"]');
    if (input && input.value && input.value !== 'not-selected') return input.value;

    return null;
  }

  function initVariantGallery(section) {
    if (section.dataset.variantGalleryReady === 'true') return;
    section.dataset.variantGalleryReady = 'true';

    var productData = parseProductData(section);
    if (!productData) return;

    var variantSelection = section.querySelector('[data-variant-selection]');
    var userInteracted = false;

    function markUserInteraction() {
      userInteracted = true;
    }

    function applyVariant(variant, forceImageUpdate) {
      syncGalleryToVariant(section, variant, forceImageUpdate || userInteracted);
    }

    function applyVariantById(variantId, forceImageUpdate) {
      applyVariant(findVariant(productData, variantId), forceImageUpdate);
    }

    section.addEventListener(
      'click',
      function (event) {
        if (
          event.target.closest(
            '.bcpo-image-parent, .bcpo-color-parent, .bcpo-front-button-label, #bcpo label, [data-variant-option], [data-option-input], .variant-selection, options-selection'
          )
        ) {
          markUserInteraction();
          setTimeout(function () {
            applyVariantById(getSelectedVariantId(section), true);
          }, 0);
        }
      },
      true
    );

    section.addEventListener('change', function (event) {
      if (event.target.matches('select[name="id"], input[name="id"]')) {
        markUserInteraction();
        applyVariantById(event.target.value, true);
      }
    });

    if (variantSelection) {
      variantSelection.addEventListener(
        'variant-change',
        function (event) {
          applyVariant(event.detail && event.detail.variant, userInteracted);
        },
        true
      );

      new MutationObserver(function () {
        if (userInteracted) {
          applyVariantById(getSelectedVariantId(section), true);
        }
      }).observe(variantSelection, {
        attributes: true,
        attributeFilter: ['variant'],
      });
    }
  }

  function bindToggleKeydown(btn, handler) {
    btn.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handler();
      }
    });
  }

  function createMoreBtn(hiddenCount) {
    var moreBtn = document.createElement('div');
    moreBtn.className = 'bcpo-swatches-more';
    moreBtn.setAttribute('role', 'button');
    moreBtn.setAttribute('tabindex', '0');
    moreBtn.innerHTML =
      '<div class="bcpo-swatches-more-inner"><span>+' +
      hiddenCount +
      '</span><span>more</span></div>';
    return moreBtn;
  }

  function createLessBtn() {
    var lessBtn = document.createElement('div');
    lessBtn.className = 'bcpo-swatches-less';
    lessBtn.setAttribute('role', 'button');
    lessBtn.setAttribute('tabindex', '0');
    lessBtn.innerHTML =
      '<div class="bcpo-swatches-more-inner"><span>-</span><span>less</span></div>';
    return lessBtn;
  }

  function setupSwatchesToggle(container, items, hiddenItems, hiddenCount) {
    var moreBtn = createMoreBtn(hiddenCount);
    var lessBtn = null;
    var expanded = false;

    items[VISIBLE_COUNT - 1].after(moreBtn);

    function expandSwatches() {
      if (expanded) return;
      expanded = true;

      moreBtn.remove();
      hiddenItems.forEach(function (item) {
        item.classList.remove('bcpo-image-parent--hidden');
      });

      lessBtn = createLessBtn();
      items[items.length - 1].after(lessBtn);
      lessBtn.addEventListener('click', collapseSwatches);
      bindToggleKeydown(lessBtn, collapseSwatches);
    }

    function collapseSwatches() {
      if (!expanded) return;
      expanded = false;

      lessBtn.remove();
      lessBtn = null;
      hiddenItems.forEach(function (item) {
        item.classList.add('bcpo-image-parent--hidden');
      });
      items[VISIBLE_COUNT - 1].after(moreBtn);
    }

    moreBtn.addEventListener('click', expandSwatches);
    bindToggleKeydown(moreBtn, expandSwatches);
  }

  function processSwatchesContainer(container) {
    if (container.dataset.bcpoSwatchesProcessed === 'true') return;

    var items = container.querySelectorAll('.bcpo-image-parent');
    if (items.length < MIN_ITEMS) return;

    container.dataset.bcpoSwatchesProcessed = 'true';

    var hiddenCount = items.length - VISIBLE_COUNT;
    var hiddenItems = [];

    items.forEach(function (item, index) {
      if (index >= VISIBLE_COUNT) {
        item.classList.add('bcpo-image-parent--hidden');
        hiddenItems.push(item);
      }
    });

    setupSwatchesToggle(container, items, hiddenItems, hiddenCount);
  }

  function scan(root) {
    root.querySelectorAll('.bcpo-jumbo-swatches').forEach(processSwatchesContainer);
  }

  function initSwatches() {
    scan(document);

    var section = document.querySelector('[data-product-component]');
    var target = section || document.body;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.classList && node.classList.contains('bcpo-jumbo-swatches')) {
            processSwatchesContainer(node);
          } else if (node.querySelectorAll) {
            scan(node);
          }
        });
      });
    });

    observer.observe(target, { childList: true, subtree: true });
  }

  var productSection = document.querySelector('[data-product-component]');
  if (productSection) {
    initVariantGallery(productSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatches);
  } else {
    initSwatches();
  }
})();
